import { gql, useMutation } from '@apollo/client'

import { cleanRequest } from './cleanRequest'
import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { useNotification } from '@btime/react-messager'

const MUTATION = gql`
  mutation UpsertServiceOrders($inputs: [ServiceOrderInput]) {
    upsertServiceOrders(inputs: $inputs) {
      id
    }
  }
`

export const useSaveServiceOrders = () => {
  const notify = useNotification()
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['ServiceOrders'], client: serviceOrdersClient })

  const handleRequest = serviceOrders => {
    const inputs = cleanRequest(serviceOrders)

    request({ variables: { inputs } }).then(resp => {
      if (!resp.errors) {
        closeModal()
        return
      }
      notify.error({ title: 'Ocorreu um erro ao criar as atividades' })
    })
  }

  return [handleRequest, state]
}
